<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="secondary"
    flat
    height="75"
  >
    <v-btn
      class="mr-3 white--text"
      text
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : setDrawer(!drawer)"
    >
      <v-icon v-if="drawer">
        mdi-arrow-collapse-left
      </v-icon>

      <v-icon v-else>
        mdi-menu
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light white--text"
      v-text="$route.name"
    />

    <v-spacer />

    <div class="mx-3" />

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2 white--text"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
          <span class="ml-2">{{ user.name }}</span>
        </v-btn>
      </template>

      <v-list 
        dense
      >
        <template v-for="(p, i) in profileMenu">
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <v-list-item
            v-else
            :key="`item-${i}`"
            @click="p.method"
            link
          >
            <v-list-item-title v-text="p.title" />
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Utilities
import { mapGetters } from 'vuex'


export default {
  name: "CoreAppBar",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      profileMenu: [
        { title: 'Изход', method: this.signOut },
      ],
    }
  },
  mounted(){
    if(!this.$vuetify.breakpoint.smAndDown){
      const vue = this;
      setTimeout(() => {
        vue.$store.state.app.drawer = true;
        vue.$forceUpdate();
      }, 0)
    } else {
      const vue = this;
      setTimeout(() => {
        vue.$store.state.app.drawer = false;
        vue.$forceUpdate();
      }, 0)
    }
  },
  computed: {
    ...mapGetters(['user', 'drawer'])
  },
  methods: {
    setDrawer(val){
      this.$store.commit('app/SET_DRAWER', val)
    },
    signOut(){
      this.$store.dispatch('user/signout').then(() => {
        this.$router.push({path: '/login'})
      });
    }
  }
}
</script>